import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../reducers/rootReducer';
import {
  snackbarSelectors,
  removeSnackbar,
} from '../../../reducers/snackbarSlice';
import Snackbar from './Snackbar';
import { useLelyAuth } from '../../../auth/useLelyAuth';

function SnackbarsContainer() {
  const dispatch = useDispatch();
  const snackbars = useAppSelector(snackbarSelectors.selectSnackbars);
  const { user } = useLelyAuth();
  const email = user?.email;
  const isLogoutPage = useLocation().pathname === '/logout';
  const closedTemporarySnackbars = useAppSelector(
    snackbarSelectors.selectClosedTemporarySnackbars,
  );
  const closedPersistentSnackbars = useAppSelector(
    snackbarSelectors.selectClosedPersistentSnackbars,
  );

  const visibleSnackbars = email
    ? snackbars.filter((snackbar) => {
        if (
          snackbar.persistencyType === 'temporary' &&
          closedTemporarySnackbars.includes(`${snackbar.id}-${email}`)
        ) {
          return false;
        }
        if (
          snackbar.persistencyType === 'persistent' &&
          closedPersistentSnackbars.includes(`${snackbar.id}-${email}`)
        ) {
          return false;
        }
        return true;
      })
    : [];

  if (isLogoutPage) return null;

  return (
    <div className="snackbars-container">
      {email &&
        visibleSnackbars.map((snackbar) => (
          <Snackbar
            key={snackbar.id}
            snackbar={snackbar}
            onCloseSnackbar={(id) =>
              dispatch(removeSnackbar({ id, currentUser: email }))
            }
          />
        ))}
    </div>
  );
}

export default SnackbarsContainer;
